<script setup>
import { ref, computed, reactive } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { removeToken } from '@/utils/services';

const storeSert = useSertStore();

const createNewCertificate = () => {
    // removeToken();
    // storeSert.removeSessionStorage();
    storeSert.goToScreen(storeSert.screens.firstScreen)
}

</script>
<template>
    <div class="constructor">
        <div class="constructor__body thank">
            <h3 class="title3">Спасибо за ваш заказ!</h3>
            <div class="thank__header">
                <p>Спасибо, что выбрали наш фитнес комплекс! Мы уверены, что ваш подарок принесет много радости и пользы.</p>
                <p>Ваш подарочный сертификат успешно создан и отправлен на указанную вами почту.</p>
            </div>
            <div class="thank__list">
                <span><b>Что дальше?</b></span>
                <ol>
                    <li>Проверьте вашу электронную почту: Сертификат был отправлен на указанный email. Если вы не видите письмо, проверьте папку «Спам».</li>
                    <li>Отправьте сертификат получателю: Если вы указали свой email, вы можете переслать сертификат получателю вручную.</li>
                    <li>Свяжитесь с нами: Если у вас возникли вопросы или проблемы, пожалуйста, свяжитесь с нашей службой поддержки.</li>
                </ol>
            </div>
            <div class="thank__links">
                <a href="tel:+7 (123) 456-78-90" class="thank__link">
                    <svg width='40' height='40'><use href='#phone_border'></use></svg>
                    <span>+7 (123) 456-78-90</span>
                </a>
                <a href="mailto:info@therinkfitness.ru" class="thank__link">
                    <svg width='40' height='40'><use href='#mail_border'></use></svg>
                    <span>info@therinkfitness.ru</span>
                </a>
            </div>
            <a 
                :href="`#${storeSert.screens.firstScreen}`" 
                @click="createNewCertificate" 
                class="btn">
                создать еще сертификат
            </a>
        </div>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.thank {
    --gap: 1.2rem;
    @media (max-width: vars.$x480) {
        --gap: 1.5rem;
    }
}
.thank__header {
    display: grid;
    gap: var(--gap);
}
.thank__list {
    span {
        margin-bottom: var(--gap);
        @media (max-width: vars.$xx) {
            font-size: 2rem;
        }
    }
    ol {
        display: grid;
        gap: var(--gap);
        margin-bottom: 0;
        @media (max-width: vars.$x480) {
            padding-left: 2rem;
        }
    }
}
.thank__links {
    display: flex;
    gap: var(--gap);
    @media (max-width: vars.$xx) {
        flex-direction: column;
        gap: 3rem;
    }
}
.thank__link {
    display: flex;
    align-items: center;
    gap: 2rem;
    @media (hover: hover){
        &:hover {
            span {
                border-color: inherit;
            }
        }
    }
    span {
        font-weight: 700;
        font-size: 2rem;
        line-height: 160%;
        border-bottom: 1px solid transparent;
        text-wrap: nowrap;
        white-space: nowrap;
        transition: border-color var(--transition) ease-in;
    }
    svg {
        width: 4rem;
        height: 4rem;
    }
}
</style>